import { AnalysisResult, AnalyzeInput } from "./analyzerTypes";
import { supabase } from "../../lib/supabaseClient";

const API = process.env.REACT_APP_API ?? "http://localhost:8000";

export async function analyzeResume(
  input: AnalyzeInput
): Promise<AnalysisResult> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;

  if (!token) {
    throw new Error("Please sign in to analyze a job.");
  }

  const response = await fetch(`${API}/analyze`, {
    method: "POST",

    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },

    body: JSON.stringify({
      job_description: input.jobDescription,
      resume_text: input.resumeText,
      role_level: input.roleLevel ?? "mid",
      voice_style: input.voiceStyle ?? "neutral",
      lang: input.language ?? "en",
    }),
  });

  const raw = await response.text();

  if (!response.ok) {
    if (response.status === 429) {
      throw new Error("FREE_LIMIT_REACHED");
    }

    if (response.status === 401) {
      throw new Error(
        "Your session has expired. Please sign in again."
      );
    }

    throw new Error(raw || "Analyze failed");
  }

  return JSON.parse(raw) as AnalysisResult;
}